import React, { FunctionComponent } from "react";
import { AWSContent } from "../DevOps/AWSContent";
import { DigitalOceanContent } from "../DevOps/DigitalOceanContent";
import { DockerContent } from "../DevOps/DockerContent";
import { GitContent } from "../DevOps/GitContent";
import { GoogleContent } from "../DevOps/GoogleContent";
import { HerokuContent } from "../DevOps/HerokuContent";
import "./SubSkillDevOPSNavigation.css";

interface IMenuObject {
  name: string;
  componentName: string;
  link: string;
  shown: Boolean;
}

type MenuProps = {
  menuObject: IMenuObject[];
};

export const SubSkillDevOPSNavigation: FunctionComponent<MenuProps> = ({
  menuObject,
}) => {
  const aaron = (compname: String) => {
    //alert(compname);
  };
  return (
    <div className="flex items-start xs:flex-col">
      <ul
        className="nav nav-pills flex flex-col flex-wrap xs:flex-row xs:justify-between xs:w-full  list-none pl-0 mr-4 font-russosans"
        id="pills-tabVertical"
        role="tablist"
      >
        {menuObject.map((anObjectMapped, index) => {
          return (
            <li
              key={`${anObjectMapped.componentName}`}
              className="nav-item mb-2"
              role="presentation"
            >
              <a
                href={`#pills-${anObjectMapped.link}Vertical`}
                className="
          block
          font-medium
          text-xs
          xs:text-xxs
          leading-tight
          uppercase
          rounded
          px-6
          py-3
          focus:outline-none focus:ring-0
          bg-menublue
          text-white
        "
                id={`#pills-${anObjectMapped.link}-tabVertical`}
                data-bs-toggle="pill"
                data-bs-target={`#pills-${anObjectMapped.link}Vertical`}
                role="tab"
                aria-controls={`pills-${anObjectMapped.link}Vertical`}
                aria-selected="true"
                onClick={() => aaron(`${anObjectMapped.componentName}`)}
              >
                {anObjectMapped.name}
              </a>
            </li>
          );
        })}
      </ul>
      <div className="tab-content grow" id="pills-tabContentVertical">
        <div
          className="tab-pane fade show active"
          id="pills-awsVertical"
          role="tabpanel"
          aria-labelledby="pills-aws-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <AWSContent />
          </div>
        </div>

        <div
          className="tab-pane fade"
          id="pills-googleVertical"
          role="tabpanel"
          aria-labelledby="pills-google-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <GoogleContent />
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="pills-doVertical"
          role="tabpanel"
          aria-labelledby="pills-do-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <DigitalOceanContent />
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="pills-herokuVertical"
          role="tabpanel"
          aria-labelledby="pills-heroku-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <HerokuContent />
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="pills-dockerVertical"
          role="tabpanel"
          aria-labelledby="pills-docker-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <DockerContent />
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="pills-gitVertical"
          role="tabpanel"
          aria-labelledby="pills-git-tabVertical"
        >
          <div className="flex text-left font-opensans">
            <GitContent />
          </div>
        </div>
      </div>
    </div>
  );
};
